import { Injectable } from '@angular/core';

import { GetVirtualCardPinCommand } from '@core/commands/get-virtual-card-pin.command';
import { AlertService } from '@core/services/alert/alert.service';
import { LoadingService } from '@core/services/loading/loading.service';
import { BaseProductCommand } from '@shared/commands/base-product.command';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';

@Injectable({ providedIn: 'root' })
export class VirtualPinCommand extends BaseProductCommand {
  readonly type = 'virtualPin';
  readonly title = 'Запросить ПИН';
  readonly icon = 'card';
  readonly productType = ProductTypes.CARD;
  readonly isInfoAction = false;
  readonly settingsNames = undefined; // Нет серверных настроек для этой команды
  readonly order = 7; // Седьмой в actions для card

  constructor(
    private readonly loadingService: LoadingService,
    private readonly getVirtualCardPinCommand: GetVirtualCardPinCommand,
    private readonly alertService: AlertService
  ) {
    super(); // Не передаем CommandAvailabilityService, так как он не нужен
  }

  async execute(context: IProductCommandContext): Promise<void> {
    this.loadingService.showLoader(true);

    try {
      const message = await this.getVirtualCardPinCommand
        .execute({ id: context.data.id })
        .toPromise();

      this.loadingService.showLoader(false);
      this.alertService.showInfoAlert(message);
    } catch (error) {
      this.loadingService.showLoader(false);
      if (error) {
        this.alertService.showErrorAlert(error);
      }
      throw error;
    }
  }

  protected checkAdditionalAvailability(context: IProductCommandContext): boolean {
    const product = context.data;

    return !!product.isVirtual;
  }
}
